import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import { CompanyInitialState } from '../entities/companies-entities';
import { ProfileInitialState } from '../entities/profile-entities';
import { ProviderInitialState } from '../entities/providers-entities';
export const CompanyInfosContext = React.createContext(null);
CompanyInfosContext.displayName = 'CompanyInfosContext';
export const CompanyInfosProvider = ({ children, company = CompanyInitialState, contacts = [], provider = ProviderInitialState, profile = ProfileInitialState, }) => {
    const contextValue = useMemo(() => {
        return {
            company,
            contacts,
            provider,
            profile,
        };
    }, [company, contacts, provider, profile]);
    return (_jsx(CompanyInfosContext.Provider, { value: contextValue, children: children }));
};
export const useCompanyInfos = () => {
    const context = useContext(CompanyInfosContext);
    if (!context) {
        throw new Error('useCompanyInfos must be used within a CompanyInfosProvider');
    }
    return context;
};
export default CompanyInfosProvider;
